<div class="flex justify-content-center p-3">
  <div class="w-full max-w-4xl">
    <p-card>
      <ng-template pTemplate="header">
        <div class="text-center py-3">
          <img src="assets/img/homelogo.png" alt="Circle Cart" class="mb-2" style="max-height: 60px; width: auto;">
          <h1 class="text-2xl font-bold m-0">How to delete your account</h1>
        </div>
      </ng-template>
      
      <div class="mb-3 p-2 surface-100 border-left-3 border-orange-500">
        <div class="text-sm text-600">
          <strong>Note:</strong> Deleting your account is irreversible, this action can't be reversed even if you delete account by accident.
        </div>
      </div>
      
      <p-divider class="my-3"></p-divider>
      
      <div class="line-height-3">
        <p>You can delete your account from within Circle Cart App. You'll need to be logged into the account you wish to delete, and account deletion can only be performed from your device.</p>

        <p>As a reminder, Circle Cart can't restore or account details, product listing, orders, trusted connections from deleted accounts.</p>

        <h3 class="text-lg font-semibold mt-4 mb-2">To delete your account</h3>
        <ol class="pl-4">
          <li>Open circle cart app</li>
          <li>Login with your credentials or OTP</li>
          <li>Open the profile screen</li>
          <li>Tap "Delete my Account"</li>
          <li>Confirm the deletion</li>
        </ol>

        <h3 class="text-lg font-semibold mt-4 mb-2">We can't delete your account</h3>
        <p>For security reasons, we can't delete an account for you. You'll need to be able to log into your account to request deletion. If you can't remember your password or username, you can reset your login data using reset password flow.</p>

        <h3 class="text-lg font-semibold mt-4 mb-2">What Happens When You Delete Your Account</h3>
        <p>When you confirm deletion:</p>
        <ul class="pl-4">
          <li>Your user account, profile, and login credentials (mobile number, email, username, password) will be deleted.</li>
          <li>All associated personal data (such as preferences, saved carts, trusted connections and transaction history) will be permanently erased from our servers after 1 days.</li>
          <li>You will not be able to re-register to the app if you wish, during the deletion process.</li>
          <li>Verification tokens, authentication logs, and OTPs are purged automatically.</li>
        </ul>

        <p>We may retain certain log data in our databases even after you delete your account, but such data will be disassociated from any identifying information such that it can no longer be linked to your account. To do this we regularly wipe certain identifying information from this log data.</p>

        <p>Please refer to our <a href="/circlecart-privacy-policy" target="_blank" class="text-primary no-underline">Privacy Policy</a> for more information.</p>

        <h3 class="text-lg font-semibold mt-4 mb-2">Contact</h3>
        <p>If you have questions about this policy or need help deleting your account, contact us at:</p>
        <p><a href="mailto:contact&#64;circlecart.app" class="text-primary no-underline">contact&#64;circlecart.app</a></p>
      </div>
      
      <ng-template pTemplate="footer">
        <div class="text-center" style="background: #1f2937; color: white; padding: 1rem; margin: -1rem -1rem -1rem -1rem;">
          <p class="m-0">
            &copy; {{ currentYear }} 
            <a href="https://techietechit.com/" target="_blank" style="color: #d1d5db; text-decoration: none;">
              TechieTech IT Services LLP.
            </a>All rights reserved.
          </p>
        </div>
      </ng-template>
    </p-card>
  </div>
</div>